<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    <button mat-icon-button [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #moreActionsMenu="matMenu">
      <button mat-menu-item (click)="delete(reportEquipment)" [disabled]="!editable">
        <mat-icon>delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>

    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="editing = !editing" [disabled]="!editable">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  @if (initialized) {
    <form [formGroup]="inputForm">
      <div class="container">
        <!-- title section -->
        <section class="header">
          <div class="title">{{reportEquipment.type}}</div>
        </section>
        <!-- /title section -->
        <nav mat-tab-nav-bar class="sub-nav">
          <a mat-tab-link active="active">Details</a>
          <a mat-tab-link>Discussion</a>
        </nav>
        <!-- Rental -->
        <section>
          <div class="mat-body-2 row">
            <div>Rental:</div>
            <div class="icons">
              <mat-slide-toggle [(ngModel)]="reportEquipment.is_rental" [ngModelOptions]="{standalone: true}"
                [disabled]="!editing">
              </mat-slide-toggle>
            </div>
          </div>
        </section>
        <!-- /Rental -->
        <!-- Sub contractor -->
        <section>
          @if (!editing) {
            <div class="mat-body-2 row">Sub contractor:</div>
          }
          @if (!editing) {
            <div class="mat-body capitalize">{{reportEquipment.sub_contractor?.name}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <mat-label>Sub contractor</mat-label>
              <mat-select formControlName="sub_contractor_id" [errorStateMatcher]="matcher">
                <mat-option>None</mat-option>
                @for (sc of subContractors; track sc) {
                  <mat-option [value]="sc.id">
                    <div>{{sc.name}}</div>
                  </mat-option>
                }
              </mat-select>
              @if (inputForm.controls.sub_contractor_id.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.sub_contractor_id.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.sub_contractor_id.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /Sub contractor -->
        <!-- type section -->
        <section>
          <div class="mat-body-2 row">Equipment:</div>
          @if (!editing) {
            <div class="mat-body">{{reportEquipment.type}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="text" autocomplete="off" formControlName="type" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.type.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.type.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.type.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /type section -->
        <!-- quantity section -->
        <section>
          <div class="mat-body-2 row">Quantity:</div>
          @if (!editing) {
            <div class="mat-body">{{reportEquipment.quantity}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" autocomplete="off" formControlName="quantity" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.quantity.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.quantity.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.quantity.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /quantity section -->
        <!-- duration section -->
        <section>
          <div class="mat-body-2 row">Hours:</div>
          @if (!editing) {
            <div class="mat-body">{{reportEquipment.duration}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" autocomplete="off" formControlName="duration" [errorStateMatcher]="matcher" />
              @if (inputForm.controls.duration.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.duration.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.duration.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /duration section -->
        <!-- idle_duration section -->
        <section>
          <div class="mat-body-2 row">Hours idle:</div>
          @if (!editing) {
            <div class="mat-body">{{reportEquipment.idle_duration}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <input matInput type="number" autocomplete="off" formControlName="idle_duration"
                [errorStateMatcher]="matcher" />
              @if (inputForm.controls.idle_duration.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.idle_duration.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.idle_duration.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /idle_duration section -->
        <!-- note section -->
        <section>
          <div class="mat-body-2 row">Note:</div>
          @if (!editing) {
            <div class="mat-body">{{reportEquipment.comment}}</div>
          }
          @if (editing) {
            <mat-form-field>
              <textarea matInput formControlName="comment" [errorStateMatcher]="matcher">
              </textarea>
              @if (inputForm.controls.comment.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.comment.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.comment.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </section>
        <!-- /note section -->
        <!-- Form Actions -->
        <section>
          @if (editing) {
            <div class="row">
              <button [disabled]="!editable" mat-stroked-button color="accent" (click)="saveItem()">
                @if (reportEquipment.id) {
                  Update
                }
                @if (!reportEquipment.id) {
                  Create
                }
              </button>
              <button mat-stroked-button (click)="onCancel()">Cancel</button>
            </div>
          }
        </section>
        <!-- Form Actions -->
      </div>
    </form>
  }

</div>
